import { F1RulesContent } from '../constants'

interface F1RulesSheetProps {
  rules: F1RulesContent
  onClose: () => void
}

// Participation rules bottom sheet (Figma 5561:7508): green panel over the
// dimmed onboarding with the rules list (arrow bullets) and a close X.
const F1RulesSheet = ({ rules, onClose }: F1RulesSheetProps) => {
  return (
    <div className="f1-rules" role="dialog" aria-label={rules.title}>
      <div className="f1-rules__backdrop" onClick={onClose} />
      <div className="f1-rules__sheet">
        <button type="button" className="f1-rules__close" aria-label="Cerrar" onClick={onClose}>
          ×
        </button>
        <h2 className="f1-rules__title">{rules.title}</h2>
        {rules.intro && <p className="f1-rules__intro">{rules.intro}</p>}
        <ul className="f1-rules__list">
          {rules.items.map((item) => (
            <li key={item.slice(0, 24)} className="f1-rules__item">
              <span className="f1-rules__arrow" aria-hidden="true">→</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default F1RulesSheet
